import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MainLayout } from "@/components/layout/MainLayout";
import { Helmet } from "react-helmet";
import { EmailKeyboard } from "@/components/aac/EmailKeyboard";
import { useTranslation } from "@/hooks/useTranslation";
import { useToast } from "@/hooks/use-toast";

export default function AACKeyboardSend() {
  const { dir, lang } = useTranslation();
  const navigate = useNavigate();
  const { toast } = useToast();
  const isHebrew = lang === "he" || lang === "ar";
  
  // Get text from sessionStorage (the message to send)
  const messageText = sessionStorage.getItem("sendMessageText") || "";
  const [emailAddress, setEmailAddress] = useState("");

  // Redirect if no message (use replace to not pollute history)
  useEffect(() => {
    if (!messageText) {
      navigate("/aac-keyboard", { replace: true });
    }
  }, [messageText, navigate]);

  const handleSend = () => {
    if (!emailAddress.trim() || !emailAddress.includes("@")) {
      toast({
        title: isHebrew ? "כתובת אימייל לא תקינה" : "Invalid email address",
        variant: "destructive",
      });
      return;
    }

    // Open email client with the message
    const subject = encodeURIComponent(isHebrew ? "הודעה מ-My EyeControl" : "Message from My EyeControl");
    const body = encodeURIComponent(messageText);
    window.location.href = `mailto:${emailAddress}?subject=${subject}&body=${body}`;
    
    // Clean up and navigate back
    sessionStorage.removeItem("sendMessageText");
    navigate("/aac-keyboard", { state: { clearText: true } });
  };

  if (!messageText) return null;

  return (
    <>
      <Helmet>
        <title>{isHebrew ? "שליחת הודעה" : "Send Message"} - Ayuni</title>
      </Helmet>

      <MainLayout>
        <div className="flex-1 flex flex-col overflow-hidden p-4" dir={dir}>
          <EmailKeyboard
            value={emailAddress}
            onChange={setEmailAddress}
            onSend={handleSend}
            className="flex-1"
          />
        </div>
      </MainLayout>
    </>
  );
}
